const MOBILE_NAV_MQ = window.matchMedia("(max-width: 989px)");

class MobileBottomNav extends HTMLElement {
  constructor() {
    super();
    this.bodyClass = "has-mobile-bottom-nav";
    this.isMobileActive = false;
    this.onBreakpointChange = this.handleBreakpointChange.bind(this);
    this.onCartClick = this.handleCartClick.bind(this);
    this.onCartUpdate = this.handleCartUpdate.bind(this);
    this.onCartRefresh = () => this.syncCartCount();
    this.onCartBubbleChange = this.syncCartCount.bind(this);
  }

  connectedCallback() {
    this.badge = this.querySelector("[data-cart-count]");
    this.badgeNum = this.querySelector("[data-cart-count-num]");
    this.cartBtn = this.querySelector('[data-action="cart"]');

    this.cartBtn?.addEventListener("click", this.onCartClick);

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      this.cartUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
    }

    document.addEventListener("cart-drawer:refresh", this.onCartRefresh);

    const cartBubble = document.getElementById("cart-icon-bubble");
    if (cartBubble && typeof MutationObserver !== "undefined") {
      this.cartObserver = new MutationObserver(this.onCartBubbleChange);
      this.cartObserver.observe(cartBubble, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    MOBILE_NAV_MQ.addEventListener("change", this.onBreakpointChange);
    this.bar = this.querySelector(".mobile-bottom-nav__bar");
    this.onBarClick = this.handleBarClick.bind(this);
    this.bar?.addEventListener("click", this.onBarClick);
    this.syncMobileState();
    this.syncCartCount();
  }

  disconnectedCallback() {
    MOBILE_NAV_MQ.removeEventListener("change", this.onBreakpointChange);
    this.bar?.removeEventListener("click", this.onBarClick);
    this.cartBtn?.removeEventListener("click", this.onCartClick);
    document.removeEventListener("cart-drawer:refresh", this.onCartRefresh);
    this.cartUnsubscribe?.();
    this.cartObserver?.disconnect();
    document.body.classList.remove(this.bodyClass);
    this.hidden = true;
  }

  handleBreakpointChange() {
    this.syncMobileState(true);
  }

  syncMobileState(animate = false) {
    if (MOBILE_NAV_MQ.matches) {
      const enteringMobile = !this.isMobileActive;
      this.isMobileActive = true;
      this.hidden = false;
      document.body.classList.add(this.bodyClass);

      if (animate && enteringMobile) {
        this.playEnterAnimation();
      } else {
        this.classList.add("mobile-bottom-nav--ready");
      }
      return;
    }

    this.isMobileActive = false;
    this.hidden = true;
    this.classList.remove("mobile-bottom-nav--ready");
    document.body.classList.remove(this.bodyClass);
  }

  playEnterAnimation() {
    if (this.classList.contains("mobile-bottom-nav--ready")) return;

    requestAnimationFrame(() => {
      this.classList.add("mobile-bottom-nav--ready");
    });
  }

  handleCartClick(event) {
    event.preventDefault();
    this.playTapFeedback(event.currentTarget);

    if (document.body.classList.contains("template-cart")) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const trigger = document.querySelector(".wt-cart__trigger");
    if (trigger) {
      trigger.click();
      return;
    }
    window.location.href = window.routes?.cart_url || "/cart";
  }

  handleBarClick(event) {
    const item = event.target.closest(".mobile-bottom-nav__item");
    if (!item || item === this.cartBtn) return;
    this.playTapFeedback(item);
  }

  playTapFeedback(item) {
    if (!item || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    item.classList.remove("mobile-bottom-nav__item--tap");
    void item.offsetWidth;
    item.classList.add("mobile-bottom-nav__item--tap");
    window.setTimeout(() => item.classList.remove("mobile-bottom-nav__item--tap"), 180);
  }

  handleCartUpdate(data) {
    if (data?.cartData?.item_count != null) {
      this.setCartCount(data.cartData.item_count);
      return;
    }
    this.syncCartCount();
  }

  async syncCartCount() {
    const fromDom = this.readCountFromDom();
    if (fromDom != null) {
      this.setCartCount(fromDom);
      return;
    }

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`);
      if (!response.ok) return;
      const cart = await response.json();
      this.setCartCount(cart.item_count || 0);
    } catch {
      /* ignore */
    }
  }

  readCountFromDom() {
    const counter = document.querySelector(
      "#cart-icon-bubble .wt-header__panel__counter",
    );
    if (counter) {
      return parseInt(counter.textContent, 10) || 0;
    }

    const bubble = document.getElementById("cart-icon-bubble");
    if (!bubble) return null;

    const text = bubble.textContent?.replace(/\D/g, "") || "";
    if (!text) return 0;
    return parseInt(text, 10) || 0;
  }

  setCartCount(count) {
    if (!this.badge) return;

    const safeCount = Math.max(0, parseInt(count, 10) || 0);
    const countEl = this.badgeNum || this.badge;
    const changed = countEl.textContent !== String(safeCount);

    countEl.textContent = safeCount;
    this.badge.classList.toggle("mobile-bottom-nav__badge--empty", safeCount === 0);
    this.badge.classList.toggle("mobile-bottom-nav__badge--wide", safeCount > 9);
    this.cartBtn?.classList.toggle("mobile-bottom-nav__item--has-cart", safeCount > 0);

    if (changed && safeCount > 0) {
      this.badge.classList.remove("mobile-bottom-nav__badge--pulse");
      void this.badge.offsetWidth;
      this.badge.classList.add("mobile-bottom-nav__badge--pulse");
      window.setTimeout(
        () => this.badge.classList.remove("mobile-bottom-nav__badge--pulse"),
        360,
      );
    }
  }
}

customElements.define("mobile-bottom-nav", MobileBottomNav);
